import { loc } from "../../../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import "../../internals/BaseHeader.js";
import "../../internals/BaseFooter.js";
import BaseForm from "../../internals/BaseForm.js";
import "../../internals/BaseFormWithPolling.js";
import "../../internals/BaseOktaVerifyChallengeView.js";
import BaseView from "../../internals/BaseView.js";
import "../../components/AuthenticatorEnrollOptions.js";
import "../../components/AuthenticatorVerifyOptions.js";
import "../../../../../packages/@okta/courage-dist/esm/lib/underscore/underscore-min.js";
import "cross-fetch";
import "../../../../util/BrowserFeatures.js";
import "../../../../util/FactorUtil.js";
import "../../../../v1/views/admin-consent/ScopeList.js";
import "../../../../v1/views/consent/ScopeList.js";
import "../captcha/CaptchaView.js";
const Body = BaseForm.extend({
  title: function() {
    return loc("device.code.activate.title", "login");
  },
  subtitle: function() {
    return loc("device.code.activate.subtitle", "login");
  },
  events: {
    'keyup input[name="userCode"]': function(e) {
      e.preventDefault();
      this.addHyphen(e);
    }
  },
  addHyphen: function(evt) {
    const currentVal = evt.target.value;
    if (currentVal && currentVal.length === 4 && !["Backspace", "Delete", "-"].includes(evt.key)) {
      evt.target.value = currentVal.concat("-");
    }
  }
});
var DeviceCodeActivateView = BaseView.extend({
  Body
});
export { DeviceCodeActivateView as default };
